import { render } from "./AddPurchase.vue?vue&type=template&id=034cded1&scoped=true"
import script from "./AddPurchase.vue?vue&type=script&lang=js"
export * from "./AddPurchase.vue?vue&type=script&lang=js"

import "./AddPurchase.vue?vue&type=style&index=0&id=034cded1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034cded1"]])

export default __exports__